var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29952 29.178C7.29964 29.1779 7.29976 29.1778 7.29988 29.1777L7.29952 29.178ZM15.8343 1.4309L16.3098 1.58541L15.8343 1.4309L12.5445 11.5557H1.89863C1.22053 11.5557 0.938579 12.4235 1.48718 12.822L10.0999 19.0795L6.81012 29.2044C6.60058 29.8493 7.3387 30.3856 7.88731 29.987L16.5 23.7295L25.1127 29.987C25.6613 30.3856 26.3994 29.8493 26.1899 29.2044L22.9001 19.0795L31.5128 12.822C32.0614 12.4235 31.7795 11.5557 31.1014 11.5557H20.4555L17.1657 1.4309L16.6902 1.58541L17.1657 1.4309C16.9562 0.785992 16.0438 0.785977 15.8343 1.4309ZM16.6763 23.6014C16.6762 23.6015 16.676 23.6016 16.6758 23.6018L16.6763 23.6014Z",
    stroke: "url(#paint0_linear_38_13737)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_13737",
    x1: 0.5,
    y1: 17,
    x2: 32.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD7819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207692,
    stopColor: "#DEA64A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351282,
    stopColor: "#FFEB95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489744,
    stopColor: "#EFBC68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607692,
    stopColor: "#FFD67A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74359,
    stopColor: "#BE8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6C0C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty_star.d36509742b9d2d24f9c0fa561178a1b8.svg";
export { ForwardRef as ReactComponent };